<article *ngIf="location" class="card location-card">
  <div class="card-body d-flex align-items-start">
    <p class="mb-0 me-5 fs-5 fw-semibold text-primary">{{ i + 1 }}.</p>
    <div>
      <h2 class="h5 text-primary mb-2">
        {{ location.facility_name }}
      </h2>
      <address class="mb-2 small">
        <p class="m-0">{{ location.address }}</p>
        <p class="m-0 mb-5">{{ location.city }}, {{ location.state }}</p>
        <a
          [href]="'tel:' + location.phone_number"
          class="text-primary font-weight-bold text-decoration-none hover-bold"
        >
          {{ location.phone_number }}
        </a>
      </address>
      <p
        class="m-0 mb-7 small-text"
        *ngFor="let facility_type of location.facility_types"
      >
        {{ facility_type.type }}
      </p>
      <digital-platform-cta-button
        [ctaStyle]="{
          tid: 0,
          name: '',
          ctaStyle: 'button__link_primary'
        }"
        (click)="navigateToFacilityDetails()"
        data-automation-id="view-details-button"
        >View Details</digital-platform-cta-button
      >
    </div>
  </div>
</article>
